import useFetchSuggestions from './useFetchSuggestions'

export default useFetchSuggestions
